
 "use strict";

 let $ = jQuery;

 $(window).on('popstate', function($evt) {
    
    // NOTE: right now we don't really use it for much, just the gallery
    //

    window.location.reload();

 });




// WEBPACK FOOTER //
// ./tbo/js/listen/history.js